<template>
  <div>
    <div
        class="sponsor-badge"
        :style="{
			top: top,
			right: right,
			left: left,
			bottom: bottom,
			position: position,
			backgroundColor: background,
			color: color,
			maxWidth: width + 'px',
		}"
        v-if="(text || icon === 'star') && icon !== 'pinned'"
    >
      <Icon v-if="icon" class="mr-1" :type="icon" :size="iconSize" :color="iconColor" />
      {{ text }}
    </div>
    <div
        v-if="icon === 'pinned'"
        class="pinned"
        :style="{
			top: top,
			right: right,
			position: position,
		}"
    >
      <Icon color="var(--badge-pin-background)" :size="16" type="pinned" />
    </div>
  </div>

</template>

<script>
export default {
	name: 'SponsorBadge',
	props: {
		text: {
			type: String,
			default: '',
		},
		icon: {
			type: String,
			default: '',
		},
		iconSize: {
			type: Number,
			default: 10,
		},
		iconColor: {
			type: String,
			default: '#ffffff',
		},
		top: {
			type: String,
			default: '12px',
		},
		right: {
			type: String,
			default: '12px',
		},
		left: {
			type: String,
			default: '',
		},
		bottom: {
			type: String,
			default: '',
		},
		background: {
			type: String,
      default: 'var(--badge-sponsored-background)',
		},
		color: {
			type: String,
			default: '#ffffff',
		},
    position:{
      type: String,
      default: 'absolute',
    },
    width: {
      type: String,
      default: '100%',
    }
	},
}
</script>

<style scoped>
.sponsor-badge {
	min-height: 22px;
	display: flex;
	align-items: center;
	padding: 4px 8px 4px 16px;
	font: 700 12px / 100% 'Inter', sans-serif;
	clip-path: polygon(0 0, 100% 0, 100% 100%, 15px 100%) !important;
	border-top-right-radius: 8px !important;
	border-top-left-radius: 0 !important;
  text-align: end !important;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}
</style>
